export const convertPriority = (priority: string): number =>
  priority === "Alta" ? 3 : priority === "Baja" ? 1 : 2;
